export const splitArrayIntoChunks = <T>(array: T[], chunkSize: number): T[][] => {
    if (!array || !array.length) {
        return [];
    }

    const chunks = [];
    for (let i = 0; i < array.length; i += chunkSize) {
        chunks.push(array.slice(i, i + chunkSize));
    }

    return chunks;
};
